module.exports = __webpack_public_path__ + "images/backgrounds/dew/medium.3c8daf991e3132f453ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/dew/medium.jpg
// module id = BHRZ
// module chunks = 0